/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Tab_AnnotateInputs */

const en_cad_features_tab_annotate = /** @type {(inputs: Cad_Features_Tab_AnnotateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annotate`)
};

/**
* | output |
* | --- |
* | "Annotate" |
*
* @param {Cad_Features_Tab_AnnotateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_tab_annotate = /** @type {((inputs?: Cad_Features_Tab_AnnotateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Tab_AnnotateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_tab_annotate(inputs)
});
export { cad_features_tab_annotate as "cad.features.tab_annotate" }